export enum AppSubscriptionType {
    FREE = 'free',
    PRO = 'pro',
}

export enum UserSubscriptionType {
    BASIC = 'basic',
    PREMIUM = 'premium',
}
